import { render, staticRenderFns } from "./draw-roi-map.vue?vue&type=template&id=029a2124&scoped=true&"
import script from "./draw-roi-map.vue?vue&type=script&lang=ts&"
export * from "./draw-roi-map.vue?vue&type=script&lang=ts&"
import style0 from "./draw-roi-map.vue?vue&type=style&index=0&id=029a2124&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029a2124",
  null
  
)

export default component.exports